import * as http from '../../modules/http';


export const USER_REQUEST_START = 'USER_REQUEST_START';
export const USER_SUCCESS = 'USER_SUCCESS';
export const USER_FAILED = 'USER_FAILED';
export const USER_NO_PERMISSION = 'USER_NO_PERMISSION';


export function user_request_start() {
    return {
        type: USER_REQUEST_START
    };
}

export function user_success(data) {
    return {
        type: USER_SUCCESS,
        data: data
    };
}

export function user_failed() {
    return {
        type: USER_FAILED
    };
}

export function user_no_permission() {
    return {
        type: USER_NO_PERMISSION
    };
}

//
//
//Async Actions
//
//
export function fetchUserDataIfNeeded(force) {

    return (dispatch, getState) => {
        if (force || shouldFetchUserData(getState())) {
            return dispatch(fetchUserData());
        }
    };
}

function shouldFetchUserData(state) {
    if (!state.userData.status !== USER_SUCCESS) {
        return true;
    }
    else {
        return false;
    }
}

function fetchUserData() {
    return ((dispatch) => {
        dispatch(user_request_start());

        http.getFromServer('getuser',
            (response) => dispatch(user_success(response.data)),
                    () => dispatch(user_failed()),
                    () => dispatch(user_no_permission())
            );
        //setTimeout(()=> dispatch(user_success({value:'data'})),500);

    });
}


export function logout() {

    http.postToServer('logout');
    //http.getFromServer('logout');

    return {
        type: USER_NO_PERMISSION
    };
}